export enum ABGroup {
  A = 'A',
  B = 'B'
}

export interface IABStore {
  authAB: ABGroup;
}
